import React from 'react';
import { Copy, Clock, AlertTriangleIcon } from 'lucide-react';
export const CouponCard = ({
  coupon,
  onCopyCode,
  onShowHowTo
}) => {
  const isExpired = coupon.status === 'expired';
  const isExpiring = coupon.status === 'expiring';
  // Format the expiration date
  const formatDate = dateString => {
    if (dateString === '2023-11-11') return 'Tomorrow';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric'
    });
  };
  return <div className={`bg-white border rounded-lg p-4 ${isExpired ? 'opacity-60' : ''}`} data-id="element-27">
      <div className="flex items-start justify-between" data-id="element-28">
        <div className="flex items-center" data-id="element-29">
          <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center mr-3" data-id="element-30">
            {coupon.logo}
          </div>
          <div data-id="element-31">
            <h3 className="font-medium" data-id="element-32">{coupon.brand}</h3>
            <p className="text-sm text-gray-600" data-id="element-33">{coupon.description}</p>
          </div>
        </div>
        <div className="bg-gray-100 px-2 py-1 rounded text-xs font-medium" data-id="element-34">
          {coupon.code}
        </div>
      </div>
      <div className="flex items-center justify-between mt-4" data-id="element-35">
        <div className="flex items-center text-xs text-gray-500" data-id="element-36">
          <Clock size={14} className="mr-1" data-id="element-37" />
          <span data-id="element-38">
            {isExpired ? 'Expired' : 'Expires'} {formatDate(coupon.expires)}
          </span>
          {isExpiring && <div className="flex items-center ml-2 text-orange-600" data-id="element-39">
              <AlertTriangleIcon size={14} className="mr-1" data-id="element-40" />
              <span data-id="element-41">Expiring Soon</span>
            </div>}
        </div>
        <div className="flex items-center space-x-3" data-id="element-42">
          <button onClick={onShowHowTo} className="text-xs text-gray-500 hover:text-gray-700 hover:underline" data-id="element-43">
            How to use
          </button>
          <button onClick={onCopyCode} disabled={isExpired} className={`flex items-center px-3 py-1.5 rounded-lg text-sm font-medium ${isExpired ? 'bg-gray-200 text-gray-500 cursor-not-allowed' : 'bg-gray-900 text-white hover:bg-gray-800'}`} data-id="element-44">
            <Copy size={14} className="mr-1.5" data-id="element-45" />
            {isExpired ? 'Expired' : 'Copy Code'}
          </button>
        </div>
      </div>
    </div>;
};